import { Button } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import {
  FormContentContainer,
  FormFooterContainer,
  FormMainContainer,
} from '@duke-hq/ui/components/Modals/FormModalLayouts';
import { CourseReview } from '../../Courses/CourseReview';
import { useSnapshot } from 'valtio';
import { quickReferralModalState } from '../../tenantState/QuickReferralState';
import { ParticipantExistsAlert } from './ParticipantExistsAlert';

type ReviewCourseProps = {
  goToNextStep: () => void;
  goToPrevStep: () => void;
};

export function ReviewCourse({ goToNextStep, goToPrevStep }: ReviewCourseProps) {
  const snap = useSnapshot(quickReferralModalState);

  return (
    <FormMainContainer>
      <FormContentContainer>
        <ParticipantExistsAlert />
        <CourseReview course={snap.courseData} />
      </FormContentContainer>
      <FormFooterContainer>
        <Button rightIcon={<ChevronRightIcon />} onClick={goToNextStep}>
          <Trans>Next</Trans>
        </Button>
        <Button onClick={goToPrevStep} variant="tertiary" leftIcon={<ChevronLeftIcon />}>
          <Trans>Back</Trans>
        </Button>
      </FormFooterContainer>
    </FormMainContainer>
  );
}
